module.exports = __webpack_public_path__ + "img/micro-small-muted.8fec0528.svg";